import React from "react";
import Stack from "@mui/material/Stack";
import { RadioGroup } from "./components";
import { Control, Controller } from "react-hook-form";
import { Observation, verbalLabels, motorLabels, eyeOpeningLabels } from "@/resources/types";


export type GlasgowComaScoreProps = {
  control: Control<Pick<Observation, "neuro">>;
}
export const GlasgowComaScore: React.FC<GlasgowComaScoreProps> = p => {
  const { control } = p;

  return (
    <Stack gap={2}>
      <Controller
        control={control}
        name="neuro.eyeOpening"
        render={({ field: { value, onChange } }) => (
          <RadioGroup
            label="Eye Opening"
            options={[
              { label: `4        ${eyeOpeningLabels[4]}`, value: "4" },
              { label: `3        ${eyeOpeningLabels[3]}`, value: "3" },
              { label: `2        ${eyeOpeningLabels[2]}`, value: "2" },
              { label: `1        ${eyeOpeningLabels[1]}`, value: "1" },
              { label: `C        ${eyeOpeningLabels.C}`, value: "C" },
            ]}
            value={String(value)}
            setValue={v => {
              const nextValue = ((): typeof value => {
                switch (v) {
                  case "1": return 1;
                  case "2": return 2;
                  case "3": return 3;
                  case "4": return 4;
                  default: return "C";
                }
              })();

              onChange(nextValue);
            }}
          />
        )}
      />

      <Controller
        control={control}
        name="neuro.verbal"
        render={({ field: { value, onChange } }) => (
          <RadioGroup
            label="Best Verbal Response"
            options={[
              { label: `5        ${verbalLabels[5]}`, value: "5" },
              { label: `4        ${verbalLabels[4]}`, value: "4" },
              { label: `3        ${verbalLabels[3]}`, value: "3" },
              { label: `2        ${verbalLabels[2]}`, value: "2" },
              { label: `1        ${verbalLabels[1]}`, value: "1" },
              { label: `T        ${verbalLabels.T}`, value: "T" },
            ]}
            value={String(value)}
            setValue={v => {
              const nextValue = ((): typeof value => {
                switch (v) {
                  case "1": return 1;
                  case "2": return 2;
                  case "3": return 3;
                  case "4": return 4;
                  case "5": return 5;
                  default: return "T";
                }
              })();

              onChange(nextValue);
            }}
          />
        )}
      />

      <Controller
        control={control}
        name="neuro.motor"
        render={({ field: { value, onChange } }) => (
          <RadioGroup
            label="Best Motor Response"
            options={[
              { label: `6        ${motorLabels[6]}`, value: "6" },
              { label: `5        ${motorLabels[5]}`, value: "5" },
              { label: `4        ${motorLabels[4]}`, value: "4" },
              { label: `3        ${motorLabels[3]}`, value: "3" },
              { label: `2        ${motorLabels[2]}`, value: "2" },
              { label: `1        ${motorLabels[1]}`, value: "1" },
            ]}
            value={String(value)}
            setValue={v => {
              const nextValue = ((): typeof value => {
                switch (v) {
                  case "1": return 1;
                  case "2": return 2;
                  case "3": return 3;
                  case "4": return 4;
                  case "5": return 5;
                  default: return 6;
                }
              })();

              onChange(nextValue);
            }}
            helperText="Note: usually record the best arm response to physical stimuli"
          />
        )}
      />

    </Stack>
  );
};
